import type { InjectionKey, Ref } from 'vue'
import { inject, provide } from 'vue'

export type RegistrationContext = {
  countries: WindowStateCountry[]
  nationalities: WindowStateCountry[]
  incomeCategories: WindowStateIncomeCategory[]
  studyInstitutions: WindowStateStudyInstitution[]
  tenantRelations: WindowStateOption[]
  backupRelations: WindowStateOption[]
  didYouMean: Ref<Map<number, string>>
  showInsertion: boolean
}

const REGISTRATION_CONTEXT_KEY: InjectionKey<RegistrationContext> = Symbol('registrationContext')

export function provideRegistrationContext(context: RegistrationContext): void {
  provide(REGISTRATION_CONTEXT_KEY, context)
}

export function useRegistrationContext(): RegistrationContext {
  const context = inject(REGISTRATION_CONTEXT_KEY)
  if (!context) {
    throw new Error('useRegistrationContext must be used within a component that called provideRegistrationContext')
  }
  return context
}
